import React from 'react';
import { HelpCircle } from 'lucide-react';

/**
 * HelpButton - Floating help button to open help drawer
 * 
 * Usage:
 * <HelpButton onClick={() => setHelpOpen(true)} />
 */
const HelpButton = ({ onClick, className = '' }) => {
  return (
    <button
      onClick={onClick}
      className={`fixed bottom-6 right-6 z-30 bg-blue-600 hover:bg-blue-700 text-white rounded-full p-4 shadow-lg hover:shadow-xl transition-all duration-200 group ${className}`}
      aria-label="Open help"
      title="Need help? Click here"
    >
      <HelpCircle className="w-6 h-6" />
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-900 text-white text-sm px-3 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Need help?
      </span>
    </button>
  );
};

export default HelpButton;

